import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
//import apiService from '../services/apiservices'
//import { productUpdateStockTableReady} from '../redux/employees'


//import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/employeesTable.css'

class CollapsibleRow extends Component {
    constructor() {
        super()
        this.state = {
        }
        this.dialog = null
    }
    

    

    render() {
        const options = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
        }
        return (
            <div style={{ backgroundColor: "#e1e5ed",margin: "0% 4%" }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    className="table-border"
                    options={options}
                    data={this.props.row.employees_users}
                    hover={false}
                    headerStyle={{ border: '0px', color: '#000' }}
                    tableStyle={{ border: '0px' }}
                    bodyStyle={{ border: '0px', overflow: "auto" }}>

                    <TableHeaderColumn
                        dataField="user_id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal'}}>
                        Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="username"
                        className="table-header"
                        width="90"
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Username
                    </TableHeaderColumn>  

                    <TableHeaderColumn
                        dataField="user_type"
                        className="table-header"
                        width="90"
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        User Type
                    </TableHeaderColumn>       

                    <TableHeaderColumn
                        dataField="user_roles"
                        className="table-header"
                        width="90"
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        User Roles
                    </TableHeaderColumn>                    
                
                </BootstrapTable>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        employees: state.employees
    }
}

export default connect(mapStateToProps)(withRouter(CollapsibleRow))


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/CollapsibleRow.js